/** baby: Shared contact destinations for marketing pages */
export const NIN_SUPPORT_EMAIL = 'support@nin.in'
export const NIN_ENTERPRISE_EMAIL = 'enterprise@nin.in'
export const NIN_GOVTS_EMAIL = 'govts@nin.in'

export const mailtoSupport = (subject = 'NIN support request') =>
  `mailto:${NIN_SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`

export const mailtoEnterprise = (subject = 'NINX Enterprise pilot inquiry') =>
  `mailto:${NIN_ENTERPRISE_EMAIL}?subject=${encodeURIComponent(subject)}`
